import * as React from 'react';
import { SvgWrapper } from '../utils';
import type { IconProps } from '../utils';

const svg = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 65 65" width="1em" height="1em">
    <circle cx={32.5} cy={32.5} r={32.5} fill="fj-icons-bg-color" />
    <path
      d="M25.728 50.613h5.883l5.411-25.528h-5.827zm6.684-34.157l-.148.671a3.423 3.423 0 003.344 4.159h.01a3.423 3.423 0 003.35-2.72l.14-.671a3.423 3.423 0 00-3.35-4.127h-.003a3.423 3.423 0 00-3.343 2.688z"
      fill="fj-icons-primary-color"
    />
  </svg>
);

const StatusInfo = ({
  style = {
    primaryColor: 'currentColor',
    bgColor: 'transparent',
  },
  size = '1em',
  active = false,
  ...rest
}: IconProps) => (
  <SvgWrapper style={style} size={size} active={active} {...rest}>
    {svg}
  </SvgWrapper>
);

export default StatusInfo;
